import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileCTA from "./MobileCTA";
import { Toaster } from "./ui/sonner";
import useReveal from "../hooks/useReveal";

export default function Layout({ children }) {
  const location = useLocation();
  useReveal();

  useEffect(() => {
    if (location.hash) {
      // Wait a tick so the new page has rendered the target element.
      const id = location.hash.replace(/^#/, "");
      const tryScroll = (attempts = 0) => {
        const el = document.getElementById(id);
        if (el) {
          const headerOffset = 84; // sticky header height
          const top =
            el.getBoundingClientRect().top + window.scrollY - headerOffset;
          window.scrollTo({ top, behavior: "smooth" });
        } else if (attempts < 8) {
          setTimeout(() => tryScroll(attempts + 1), 60);
        }
      };
      tryScroll();
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen flex flex-col bg-[#F7F5F0] text-[#18221A]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <MobileCTA />
      <Toaster position="top-center" richColors />
    </div>
  );
}
